export default __webpack_public_path__ + "static/media/medical-gray.19aed4db.svg";